import React from 'react'
import PropTypes from 'prop-types'
import { Row, Card, Col, Icon, Tag } from 'antd';
import { IMAGES_URL } from '../../../../helper/api/Api';
import moment from 'moment';
import { toTag, is } from '../Constants';

export default class CardBox extends React.Component {
    static propTypes = {
        event: PropTypes.object.isRequired,
    }


    render() {
        const opentAt = moment(this.props.event.openAt, "YYYY-MM-DD HH:mm", 'fr');
        //const startAt = moment(this.props.event.startAt, "YYYY-MM-DD HH:mm", 'fr');
        //const closeAt = moment(this.props.event.closeAt, "YYYY-MM-DD HH:mm", 'fr');
        //const description = this.props.event.description ? (this.props.event.description.substring(0, 50) + '...') : '';
        const categories = this.props.event.eventCategory || [];

        return (
            
            <Card
                className="card"
                style={{ maxWidth: '250px'}}
                cover={<img src={ IMAGES_URL(this.props.event.images) } />}
                extra={this.props.onRemove ? <a onClick={this.props.onRemove}><Icon type="close" /></a> : null}
            >
                <Card.Meta
                    title={this.props.event.title}
                />
                <Row style={{ marginTop: '10px' }}>
                    <Col span={24}><Icon type="flag" /><strong> {categories.length > 0 ? categories[0].category.name : 'Aucune'} </strong></Col>
                </Row>
                <Row>
                    <Col span={24}><Icon type="check" /><strong> Commence : </strong>{(opentAt !== null) ? opentAt.format('DD MMMM à h:mm ') : 'Aucune information'}</Col>
                </Row>
                <Row>
                    <Col span={24}><Tag style={{ float: 'right' }}  color={toTag(is(this.props.event.status)).color}>{toTag(is(this.props.event.status)).text}</Tag></Col>
                </Row>
            </Card>
        )
    }
}


// WEBPACK FOOTER //
// ./src/features/admin/events/item/Card.js